<div>
  <!-- <select class="form-control mobile-hide my-1" [(ngModel)]="selectedEvent">
      <option [value]="item.id" *ngFor="let item of eventList;trackBy:trackByIndex;">{{item.name}}</option>
  </select> -->
  <div class="mod-header tab_bets betsheading">

      <tabset type="pills nav-fill">
          <tab id="tab1" customClass="betdata">
              <ng-template tabHeading>
                  <span class="bet-label">Matched </span>
                  <span class="bat_counter" id="cnt_row"></span>
              </ng-template>
              <div class="balance-panel-body">
                  <div class="table-responsive sports-tabel">
                      <table class="table mb-0 table-bordered">
                          <thead>
                              <tr>
                                  <th>Selection</th>
                                  <th>Odds</th>
                                  <th>Stake</th>
                                  <th>Date/Time</th>
                              </tr>
                          </thead>
                          <tbody>
                            <!-- *ngFor="let item of data.matched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;" -->
                              <tr [ngClass]="item.bet_type == 1 ? 'back' : 'lay'" *ngFor="let item of data.matched; trackBy:trackByIndex;">
                                  <td>{{item.runner_name}} {{item.market_type}} </td>
                                  <td>{{item.average_rate_matched | number}}</td>
                                  <td>{{item.stake_matched | number}}</td>
                                  <td>{{(item.matched_at_format ? item.matched_at_format : item.matched_at) | date :
                                      'dd/MM/YYYY hh:mm:ss a'}}</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </tab>
          <tab customClass="betdata">
              <ng-template tabHeading>
                  <span class="bet-label">UnMatched </span>
                  <span class="bat_counter" id="cnt_row"></span>
              </ng-template>
              <div class="balance-panel-body">
                  <div class="table-responsive sports-tabel">
                      <table class="table mb-0">
                          <thead>
                              <tr class="border-bottom">
                                  <th>Selection</th>
                                  <th>Odds</th>
                                  <th>Stake</th>
                                  <th>Date/Time</th>
                              </tr>
                          </thead>
                          <tbody>
                            <!-- *ngFor="let item of data.unMatched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;" -->
                              <tr [ngClass]="item.bet_type == 1 ? 'back' : 'lay'" *ngFor="let item of data.unMatched; trackBy:trackByIndex;">
                                  <td>{{item.runner_name}} {{item.market_type}} </td>
                                  <td>{{item.rate | number}}</td>
                                  <td>{{item.stake_remaining | number}}</td>
                                  <td>{{(item.matched_at_format ? item.matched_at_format : item.matched_at) | date :
                                      'dd/MM/YYYY hh:mm:ss a'}}</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </tab>
          <tab customClass="betdata">
              <ng-template tabHeading>
                  <span class="bet-label">Fancy </span>
                  <span class="bat_counter" id="cnt_row"></span>
              </ng-template>
              <div class="balance-panel-body">
                  <div class="table-responsive sports-tabel">
                      <table class="table mb-0">
                          <thead>
                              <tr class="border-bottom">
                                  <th>Selection</th>
                                  <th>Odds</th>
                                  <th>Stake</th>
                                  <th>Date/Time</th>
                              </tr>
                          </thead>
                          <tbody>
                            <!-- *ngFor="let item of data.fancy | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;" -->
                              <tr [ngClass]="item.bet_type == 1 ? 'back' : 'lay'" *ngFor="let item of data.fancy; trackBy:trackByIndex;">
                                  <td>{{item.runner_name}} {{item.market_type}} </td>
                                  <td>{{item.price != 100 ? (item.rate | number)+'/'+(item.price | number) :
                                      item.average_rate_matched | number}}</td>
                                  <td>{{item.stake_matched | number}}</td>
                                  <td>{{(item.matched_at_format ? item.matched_at_format : item.matched_at) | date :
                                      'dd/MM/YYYY hh:mm:ss a'}}</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </tab>
      </tabset>
  </div>

</div>


<!-- <nav class="bg-light">
  <div class="nav nav-tabs bms-tabs justify-content-center border-0" id="nav-tab" role="tablist">
    <a class="nav-item nav-link active" id="nav-Matched-tab" data-toggle="tab" href="#nav-Matched" role="tab"
      aria-controls="nav-Matched" aria-selected="true">Matched</a>
    <a class="nav-item nav-link" id="nav-Unmatched-tab" data-toggle="tab" href="#nav-Unmatched" role="tab"
      aria-controls="nav-Unmatched" aria-selected="false">Unmatched</a>
  </div>
</nav>
<div class="tab-content matched-unmatched-ui" id="nav-tabContent">
  <div class="tab-pane fade show active" id="nav-Matched" role="tabpanel" aria-labelledby="nav-Matched-tab">
    <div class="table-responsive">
      <table class="table mb-0">
        <thead>
          <tr class="border-bottom">
            <th>runners</th>
            <th>odds</th>
            <th>stakes</th>
            <th>p/l</th>
          </tr>
        </thead>
      </table>
      <table class="table mb-0">
        <thead>
          <tr>
            <th colspan="5">Match Odd</th>
          </tr>
        </thead>
        <tbody>
          <tr class="blue-bet">
            <td>The Draw</td>
            <td>3.30</td>
            <td>500</td>
            <td>1150</td>
          </tr>
          <tr class="red-bet">
            <td>The Draw</td>
            <td>3.30</td>
            <td>500</td>
            <td>1150</td>
          </tr>
        </tbody>
      </table>
      <table class="table mb-0">
        <thead>
          <tr>
            <th colspan="5">Session</th>
          </tr>
        </thead>
        <tbody>
          <tr class="red-bet">
            <td>Fall Of 5th wkt ENG</td>
            <td>266/105</td>
            <td>500</td>
            <td>525</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="tab-pane fade matched-unmatched-ui" id="nav-Unmatched" role="tabpanel"
    aria-labelledby="nav-Unmatched-tab">
    <div class="table-responsive">
      <table class="table mb-0">
        <thead>
          <tr class="border-bottom">
            <th>runners</th>
            <th>odds</th>
            <th>stakes</th>
            <th>p/l</th>
          </tr>
        </thead>
      </table>
      <table class="table mb-0">
        <thead>
          <tr>
            <th colspan="5">Match Odd</th>
          </tr>
        </thead>
        <tbody>
          <tr class="blue-bet">
            <td>The Draw</td>
            <td>3.30</td>
            <td>500</td>
            <td>1150</td>
          </tr>
          <tr class="red-bet">
            <td>The Draw</td>
            <td>3.30</td>
            <td>500</td>
            <td>1150</td>
          </tr>
        </tbody>
      </table>
      <table class="table mb-0">
        <thead>
          <tr>
            <th colspan="5">Session</th>
          </tr>
        </thead>
        <tbody>
          <tr class="red-bet">
            <td>Fall Of 5th wkt ENG</td>
            <td>266/105</td>
            <td>500</td>
            <td>525</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div> -->